import request from '@/utils/request_cn';

export function getVendorList() {
  return request({
    url: `/sc-merchant-common/v2/vendor/real-name/unit/regionFilter`,
  });
}

export function getNotOrderSettlementList(data) {
  return request({
    url: `/sc-basic-merchant-backend/merchant/nonOrder/settlement/list`,
    method: 'post',
    data,
  });
}

export function saveNotOrderSettlement(data) {
  return request({
    url: `/sc-basic-merchant-backend/merchant/nonOrder/settlement/saveOrUpdate`,
    method: 'post',
    data,
  });
}

export function delNotOrderSettlement(data) {
  return request({
    url: `/sc-basic-merchant-backend/merchant/nonOrder/settlement/del`,
    method: 'post',
    data,
  });
}

export function getListDescEnum() {
  return request({
    url: `/sc-basic-merchant-backend/merchant/nonOrder/settlement/listDescEnum`,
  });
}
export function importNotOrderSettlement(data) {
  return request({
    url: `/sc-basic-merchant-backend/merchant/nonOrder/settlement/import`,
    method: 'post',
    data,
  });
}

export function getNotOrderSettlementSaleOrderList(data) {
  return request({
    url: `/sc-basic-merchant-backend/merchant/nonOrder/settlement/saleOrder/list`,
    method: 'post',
    data,
  });
}

export function exportNotOrderSettlement(data) {
  return request({
    url: `/sc-basic-merchant-backend/merchant/nonOrder/settlement/export`,
    method: 'post',
    data,
  });
}

export function exportNotOrderSettlementResult() {
  return request({
    url: `/sc-basic-merchant-backend/merchant/nonOrder/settlement/export/result`,
    params:{
      taskCode:'pre_sale_defect_confirm_export'
    },
  });
}

export function updateAmount(data) {
  return request({
    url: `/sc-basic-merchant-backend/merchant/nonOrder/settlement/updateAmount`,
    method: 'post',
    data,
  });
}

export function confirmSettlementSaleOrder(data) {
  return request({
    url: `/sc-basic-merchant-backend/merchant/nonOrder/settlement/confirm`,
    method: 'post',
    data,
  });
}

export function delSettlementSaleOrder(data) {
  return request({
    url: `/sc-basic-merchant-backend/merchant/nonOrder/settlement/saleOrderDel`,
    method: 'post',
    data,
  });
}

export function getPortalSettleList(data) {
  return request({
    url: `/sc-basic-merchant-backend/portal/settle/list`,
    method: 'post',
    data,
  });
}

export function batchSettledPortalSettle(data) {
  return request({
    url: `/sc-basic-merchant-backend/portal/settle/batch/settled`,
    method: 'post',
    data,
  });
}

export function getPortalSettleDetail(data) {
  return request({
    url: `/sc-basic-merchant-backend/portal/settle/detail`,
    method: 'post',
    data,
  });
}

export function rollbackPortalSettle(data) {
  return request({
    url: `/sc-basic-merchant-backend/portal/settle/rollback/status`,
    method: 'post',
    data,
  });
}

export function exportPortalSettle(data) {
  return request({
    url: `/sc-basic-merchant-backend/portal/settle/export`,
    method: 'post',
    data,
  });
}

export function exportPortalSettleResult(params) {
  return request({
    url: `/sc-basic-merchant-backend/portal/settle/export/result`,
    params
  });
}
//获取业务区域列表
export function getBusinessRegionList() {
  return request({
    url: `/basic-backend/business/region/list`,
    method: "get",
  });
}

//重发邮件
export function resendEmail(params) {
  return request({
    url: `/sc-basic-merchant-backend/portal/settle/resend/email`,
    method: "get",
    params
  });
}



export function batchResendEmail(data) {
  return request({
    url: `/sc-basic-merchant-backend/portal/settle/batch/resend/email`,
    method: "post",
    data,
  });
}


export function identifiersExport(data) {
  return request({
    url: `/sc-basic-merchant-backend/portal/settle/identifiers/export`,
    method: "post",
    data,
  });
}
export function downloadInvoice(data) {
  return request({
    url: `/sc-basic-merchant-backend/portal/settle/download/invoice`,
    method: "post",
    data,
  });
}
export function downloadInvoiceResult(identifiesNo) {
  return request({
    url: `/sc-basic-merchant-backend/portal/settle/download/invoice/result/${identifiesNo}`,
  });
}
export function settleIdentifiersRateUpdate(data) {
  return request({
    url: `/sc-basic-merchant-backend/portal/settle/identifiers/rate/update`,
    method: "post",
    data,
  });
}

// 打印请款单数据
export function printIdentifiers(data) {
  return request({
    url: `/sc-basic-merchant-backend/portal/settle/print/identifiers/data`,
    method: "post",
    data,
  });
}

// 打印结算单数据
export function printIdentifiersDetail(data) {
  return request({
    url: `/sc-basic-merchant-backend/portal/settle/print/identifiers/detail/data`,
    method: "post",
    data,
  });
}

// 不可结算订单查询接口
export function settleOrderList(params) {
  return request({
    url: `/sc-basic-merchant-backend/cannot/settle/order/list`,
    method: "get",
    params
  });
}

// 通过订单信息查询其他信息
export function getSettleOrderInfo(settlementNo) {
  return request({
    url: `/sc-basic-merchant-backend/cannot/settle/order/${settlementNo}/info`,
    method: "get",
  });
}

// 提交订单废除信息
export function settleOrderSubmit(data) {
  return request({
    url: `/sc-basic-merchant-backend/cannot/settle/order/submit`,
    method: "post",
    data,
  });
}

export function identifiersRecordException(data) {
  return request({
    url: `/sc-basic-merchant-backend/portal/settle/record/exception?settlementIdentifiersId=${data.settlementIdentifiersId}&controversyStatus=${data.controversyStatus}`,
    method: "post",
  });
}
